import { FormattedMessage } from 'react-intl';

import { Props as FormattedMessageProps } from 'react-intl/src/components/message';

import { Tooltip, Typography } from '@mui/material';

export interface PropertyAmountBreakdownTitleProps {
  formattedMessageProps: FormattedMessageProps;
  tooltipMessageProps: FormattedMessageProps;
}

export const PropertyAmountBreakdownTitle = ({
  formattedMessageProps,
  tooltipMessageProps,
}: PropertyAmountBreakdownTitleProps) => {
  return (
    <Tooltip title={<FormattedMessage {...tooltipMessageProps} />} placement="top">
      <Typography sx={{ textDecoration: 'underline' }}>
        <FormattedMessage {...formattedMessageProps} />
      </Typography>
    </Tooltip>
  );
};
